import React from 'react'
import PropTypes from 'prop-types'
import { JsonLd } from 'react-schemaorg'
import { menuTreeFromPages } from '@helpers/menuHelpers'
import { HelmetDatoCms } from 'gatsby-source-datocms'
import { useStaticQuery, graphql } from 'gatsby'
import Headroom from 'react-headroom'
import { Header, Footer, Drilldown } from '@components'
import ThemeContext from '@context/themeContext'

const Layout = ({ children, pageType = '' }) => {
  const { site } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          lang
          siteUrl
        }
      }
    }
  `)

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: site.siteMetadata.title,
    description: site.siteMetadata.description,
    email: site.siteMetadata.email,
    contactPoint: [
      {
        '@type': 'ContactPoint',
        email: site.siteMetadata.email,
        contactType: 'customer service'
      }
    ],
    url: site.siteMetadata.siteUrl,
    logo: site.siteMetadata.logo,
    sameAs: [site.siteMetadata.facebook, site.siteMetadata.instagram]
  }

  const classes = ['layout']

  return (
    <>
      <HelmetDatoCms defer={false}>
        <meta name="format-detection" content="telephone=no" />
        <html lang="en" />
      </HelmetDatoCms>
      <div id="layout" className={classes.join(' ')}>
        <div className={'layout__content'}>
          <main>{children}</main>
        </div>
        

        <JsonLd item={schema} />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

export default Layout
